import { usePlayer } from '../../hooks/PlayerProvider';
import { useCurrentAsset } from '../../hooks/CurrentAssetProvider';
import { usePlayerState } from '../../hooks/usePlayerState';
import { usePaywallState } from '../../hooks/usePaywallState';
import { useProvider } from '../../hooks/useProvider';
import { useIcons } from '../../hooks/useIcons';
import { getImageSrc } from '../../utils/image';
import {
  getPodcastAccessLevel,
  isLiveStream,
} from '../../../../utils/player/asset';
import { getNativeAudioLink } from '../../utils/nativeAudioLink';
import { useTranslation } from '../../../../utils/useTranslation';
import ns from '../../translations';
import { PodcastControls } from './PodcastControls';
import { LiveTimeDisplay } from '../../components/TimeDisplay/LiveTimeDisplay';
import { PodcastMeta } from './PodcastMeta';
import { formatPublishedDate } from '@vgtv/time-helpers';

export const PodcastLayout = () => {
  const state = usePlayerState();
  const player = usePlayer();
  const { asset } = useCurrentAsset();
  const { configProvider } = useProvider();
  const { Play } = useIcons();
  const { t, i18n } = useTranslation(ns);

  const title = asset?.title || '';
  const description = asset?.description || '';
  const seriesTitle = asset?.category?.title || '';
  const isLive = asset !== undefined && isLiveStream(asset);
  const publishedDate =
    asset?.published && !isLive
      ? formatPublishedDate(asset.published, i18n.locale === 'no' ? 'nb' : 'sv')
      : '';
  const imageSrc = getImageSrc(asset?.images?.main, 224);
  const durationInMinutes =
    asset?.duration && asset.duration > 0
      ? Math.ceil(asset.duration / 1000 / 60)
      : null;
  const accessLevel = getPodcastAccessLevel(asset, configProvider);
  const { hasAccess } = usePaywallState(accessLevel);
  const nativeAudioLink = hasAccess
    ? getNativeAudioLink(asset, configProvider)
    : undefined;

  const isPlaying = state !== 'idle' && hasAccess;

  return (
    <div className="vgp-podcast-layout">
      {imageSrc && (
        <div className="vgp-podcast-layout-cover">
          <img
            className="vgp-podcast-layout-cover-image"
            src={imageSrc}
            alt={title}
          />
        </div>
      )}
      <div className="vgp-podcast-layout-content">
        <div className="vgp-podcast-layout-meta-row">
          <PodcastMeta
            title={title}
            description={description}
            seriesTitle={seriesTitle}
            publishedDate={publishedDate}
          />
          {isLive && <LiveTimeDisplay variant="podcast" />}
        </div>
        <PodcastControls
          isPlaying={isPlaying}
          hasAccess={hasAccess}
          asset={asset}
          accessLevel={accessLevel}
          durationInMinutes={durationInMinutes}
          onPlay={() => {
            player.setMute(false);
            player.play();
          }}
          nativeAudioLink={nativeAudioLink}
          playIcon={<Play />}
        />
      </div>
    </div>
  );
};
